import React from 'react';
import styles from './Modal.module.scss';
import { useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { axiosBackend } from '../../../../axios/Axios.js';
// import "./Modal.css"
import { getToken } from "../../../../services/auth";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import dayjs, { Dayjs } from 'dayjs';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from 'notistack'

export default function Modal({reloadResps, formData, setFormData, isOpen, onClose, uuid }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const MODAL_URL = "/resp";

  const [loading, setLoading] = useState(false);

  const config = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  }

  const handleSubmit = async () => {
    setLoading(true);
      await axiosBackend.post(MODAL_URL, formData, config).then( (response) => {
        reloadResps();
        enqueueSnackbar('Responsável inserido com sucesso!', { 
          variant: 'success'
        });
        setLoading(false);
        onClose();
      }).catch ((error) => {
        enqueueSnackbar('Falha ao tentar inserir responsável!', { 
          variant: 'error'
        });
        setLoading(false);
        onClose();
      });
  };

  return (
    <div className={`overlay ${isOpen ? 'open' : ''}`}>
      <div className={styles.draw_box}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
        <div className={styles.main_column}>
          <h1 className={styles.main_title}>Adicionar responsável</h1>
          <div className={styles.main_row}>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Email</label>
              <input
                required
                className={styles.input_box_1}
                placeholder="Escreva o email do usuário"tittle
                value={formData.user}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Peso (prioridade)</label>
              <div className={styles.time_div}>
              <TextField
                id="horas-contratadas"
                type="number"
                className={styles.numberField}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{ inputProps: { min: 1, max: 5 }, className: styles.numberField}}
                value={formData.weight}
                onChange={(e) => {setFormData({ ...formData, weight: e.target.value })}
                }
              />
              </div>
            </div>
          </div>
          <div className={styles.main_row}>
            <button className={styles.cancel_button} onClick={() => {
                onClose();
              }}>
              Cancelar
            </button>
            <button
              className={styles.send_button}
              onClick={() => {
                handleSubmit();
              }}
            >
              Adicionar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}